(() => {
  const ROOT_SELECTOR = "[data-itazuke-custom-order]";
  const DATA_SELECTOR = "[data-itazuke-custom-order-data]";

  const parseData = (root) => {
    const node = root.querySelector(DATA_SELECTOR);

    if (!node) {
      return null;
    }

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error("ITAZUKE Custom Order data parse failed", error);
      return null;
    }
  };

  const getPlants = (data) => {
    if (Array.isArray(data.plants)) {
      return data.plants;
    }

    return data.plant ? [data.plant] : [];
  };

  const findPlant = (data, plantId) =>
    getPlants(data).find((plant) => plant.id === plantId);

  const findCombination = (data, deckId, plantId) =>
    data.combinations.find(
      (combination) =>
        combination.deck_id === deckId && combination.plant_id === plantId
    );

  const isPlantUnavailable = (plant) => {
    if (!plant) {
      return true;
    }

    return plant.sold === true || plant.available === false;
  };

  const isUnavailable = (deck, plant, combination) => {
    if (!deck || !plant || !combination) {
      return true;
    }

    return (
      deck.sold === true ||
      deck.available === false ||
      plant.sold === true ||
      plant.available === false ||
      combination.sold === true ||
      combination.available === false
    );
  };

  const normalizeImageUrl = (url) => {
    if (!url) {
      return "";
    }

    return url.startsWith("//") ? `${window.location.protocol}${url}` : url;
  };

  const pickDeckIdForPlant = (data, plantId, preferredDeckId) => {
    const preferredDeck = data.decks.find((deck) => deck.id === preferredDeckId);
    const plant = findPlant(data, plantId);

    if (preferredDeck && plant) {
      const preferredCombination = findCombination(data, preferredDeck.id, plantId);

      if (!isUnavailable(preferredDeck, plant, preferredCombination)) {
        return preferredDeck.id;
      }
    }

    const firstAvailableDeck = data.decks.find((deck) => {
      const combination = findCombination(data, deck.id, plantId);
      return !isUnavailable(deck, plant, combination);
    });

    return firstAvailableDeck ? firstAvailableDeck.id : preferredDeckId || data.decks[0]?.id;
  };

  const pickInitialSelection = (data) => {
    const plants = getPlants(data);

    for (const plant of plants) {
      const deck = data.decks.find((item) => {
        const combination = findCombination(data, item.id, plant.id);
        return !isUnavailable(item, plant, combination);
      });

      if (deck) {
        return {
          selectedDeckId: deck.id,
          selectedPlantId: plant.id
        };
      }
    }

    return {
      selectedDeckId: data.decks[0]?.id,
      selectedPlantId: plants[0]?.id
    };
  };

  const setHidden = (element, hidden) => {
    if (element) {
      element.hidden = hidden;
    }
  };

  const setText = (element, value) => {
    if (element) {
      element.textContent = value || "";
    }
  };

  const init = (root) => {
    if (root.dataset.itazukeCustomOrderReady === "true") {
      return;
    }

    const data = parseData(root);
    const plants = data ? getPlants(data) : [];

    if (
      !data ||
      !Array.isArray(data.decks) ||
      !Array.isArray(data.combinations) ||
      plants.length === 0
    ) {
      return;
    }

    root.dataset.itazukeCustomOrderReady = "true";

    const deckButtons = Array.from(root.querySelectorAll("[data-deck-button]"));
    const plantButtons = Array.from(root.querySelectorAll("[data-plant-button]"));
    const previewImage = root.querySelector("[data-preview-image]");
    const previewPlaceholder = root.querySelector("[data-preview-placeholder]");
    const previewPlaceholderName = root.querySelector("[data-preview-placeholder-name]");
    const previewSoldNote = root.querySelector("[data-preview-sold-note]");
    const summarySoldNote = root.querySelector("[data-summary-sold-note]");
    const summaryDeck = root.querySelector("[data-summary-deck]");
    const summaryPlant = root.querySelector("[data-summary-plant]");
    const summaryPrice = root.querySelector("[data-summary-price]");
    const summaryCareLink = root.querySelector("[data-summary-care-link]");
    const buyButton = root.querySelector("[data-buy-button]");
    const cartError = root.querySelector("[data-cart-error]");

    const initialSelection = pickInitialSelection(data);

    let previewRequestId = 0;
    
        const state = {
      selectedDeckId: initialSelection.selectedDeckId,
      selectedPlantId: initialSelection.selectedPlantId,
      isSubmitting: false
    };

    const getDeck = () => data.decks.find((deck) => deck.id === state.selectedDeckId);
    const getPlant = () => findPlant(data, state.selectedPlantId);
    const getCombination = () =>
      findCombination(data, state.selectedDeckId, state.selectedPlantId);

    const showPreviewError = () => {
      previewImage.removeAttribute("src");
      previewImage.alt = "";
      previewImage.hidden = true;
      previewPlaceholder.hidden = false;
      setText(previewPlaceholderName, "画像を読み込めませんでした");
      };

      const renderPreview = (combination) => {
      if (!previewImage || !previewPlaceholder) {
      return;
      }

      const requestId = ++previewRequestId;

      if (!combination?.preview_image) {
      previewImage.removeAttribute("src");
      previewImage.alt = "";
      previewImage.hidden = true;
      previewPlaceholder.hidden = false;
      setText(previewPlaceholderName, combination?.preview_file || "");
      return;
      }

      const nextSrc = combination.preview_image;
      const nextAlt = `${combination.deck_name} / ${combination.plant_name} preview`;
      const loader = new Image();

      loader.onload = () => {
      if (requestId !== previewRequestId) {
      return;
      }
      if (!(loader.complete && loader.naturalWidth > 0)) {
      showPreviewError();
      return;
      }
      previewImage.src = nextSrc;
      previewImage.alt = nextAlt;
      previewImage.hidden = false;
      previewPlaceholder.hidden = true;
      };

      loader.onerror = () => {
      if (requestId !== previewRequestId) {
      return;
      }
      showPreviewError();
      };

      loader.src = nextSrc;
      };

    const render = () => {
      const deck = getDeck();
      const plant = getPlant();
      const combination = getCombination();
      const unavailable = isUnavailable(deck, plant, combination);

      deckButtons.forEach((button) => {
        const deckId = button.dataset.deckId;
        const buttonDeck = data.decks.find((item) => item.id === deckId);
        const buttonCombination = findCombination(data, deckId, state.selectedPlantId);
        const buttonUnavailable = isUnavailable(buttonDeck, plant, buttonCombination);
        const isSelected = deckId === state.selectedDeckId;

        button.classList.toggle("is-selected", isSelected);
        button.classList.toggle("is-sold", buttonUnavailable);
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        button.disabled = buttonUnavailable;
      });

      plantButtons.forEach((button) => {
        const plantId = button.dataset.plantId;
        const buttonPlant = findPlant(data, plantId);
        const buttonUnavailable = isPlantUnavailable(buttonPlant);
        const isSelected = plantId === state.selectedPlantId;

        button.classList.toggle("is-selected", isSelected);
        button.classList.toggle("is-sold", buttonUnavailable);
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        button.disabled = buttonUnavailable;
      });

      renderPreview(combination);

      setText(summaryDeck, combination?.deck_name || deck?.name || "");
      setText(summaryPlant, combination?.plant_name || plant?.name || "");
      setText(summaryPrice, combination?.price_text || "");

      if (summaryCareLink) {
        if (plant?.care_url) {
          summaryCareLink.href = plant.care_url;
          summaryCareLink.hidden = false;
        } else {
          summaryCareLink.hidden = true;
        }
      }

      setHidden(previewSoldNote, !unavailable);
      setHidden(summarySoldNote, !unavailable);

      if (buyButton) {
        buyButton.disabled = unavailable || state.isSubmitting;
        buyButton.textContent = state.isSubmitting
          ? "追加中..."
          : unavailable
            ? "販売対象外です"
            : "この組み合わせで購入する";
      }
    };

    deckButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) {
          return;
        }

        state.selectedDeckId = button.dataset.deckId;

        if (cartError) {
          cartError.textContent = "";
          cartError.hidden = true;
        }

        render();
      });
    });

    plantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) {
          return;
        }

        state.selectedPlantId = button.dataset.plantId;
        state.selectedDeckId = pickDeckIdForPlant(
          data,
          state.selectedPlantId,
          state.selectedDeckId
        );

        if (cartError) {
          cartError.textContent = "";
          cartError.hidden = true;
        }

        render();
      });
    });

    if (buyButton) {
      buyButton.addEventListener("click", async () => {
        const deck = getDeck();
        const plant = getPlant();
        const combination = getCombination();

        if (isUnavailable(deck, plant, combination) || state.isSubmitting) {
          return;
        }

        state.isSubmitting = true;

        if (cartError) {
          cartError.textContent = "";
          cartError.hidden = true;
        }

        render();

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: combination.variant_id,
              quantity: 1,
              properties: {
                _itazuke_preview_image: normalizeImageUrl(combination.preview_image),
                _itazuke_preview_alt: `${combination.deck_name} / ${combination.plant_name}`
              }
            })
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || errorData.message || "カート追加に失敗しました。");
          }

          window.location.href = "/cart";
        } catch (error) {
          if (cartError) {
            cartError.textContent = error.message || "カート追加に失敗しました。時間をおいて再度お試しください。";
            cartError.hidden = false;
          }
        } finally {
          state.isSubmitting = false;
          render();
        }
      });
    }

    render();
  };

  const initAll = (container = document) => {
    container.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();